import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { FactStrip } from './components/FactStrip';
import { Problems } from './components/Problems';
import { CollectionIntro } from './components/CollectionIntro';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { TeachingProcess } from './components/TeachingProcess';
import { Offer } from './components/Offer';
import { UseCases } from './components/UseCases';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyMobileCta } from './components/StickyMobileCta';
import { siteConfig } from './data/siteConfig';
import { setPageMeta } from './utils/seo';
type AppProps = {
  showStickyMobileCta?: boolean;
};
export function App({
  showStickyMobileCta = true
}: AppProps) {
  useEffect(() => {
    setPageMeta(siteConfig.seo.title, siteConfig.seo.description);
  }, []);
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-charcoal" data-id="element-0" data-mp="3mlj8gtrwtb2j">
      <TopBar data-id="element-1" data-mp="3mjg93j4va5l5" />
      <main data-id="element-2" data-mp="3rc9e8848zfxr">
        <Hero data-id="element-3" data-mp="3rcj31sdk3h1v" />
        <FactStrip data-id="element-4" data-mp="3rbzo8kj7d8s2" />
        <Problems data-id="element-5" data-mp="3rdkgu4lyihna" />
        <CollectionIntro data-id="element-6" data-mp="3rd189ei755lx" />
        <Volumes data-id="element-7" data-mp="5yhupa6n3cr" />
        <Bonuses data-id="element-8" data-mp="6hq1ea16ddl" />
        <TeachingProcess data-id="element-9" data-mp="4wwnrzgd0hb" />
        <Offer data-id="element-10" data-mp="56lvdcob3ly" />
        <UseCases data-id="element-11" data-mp="7suzhf7pr6a" />
        <Guarantee data-id="element-12" data-mp="2zld0746gb58w" />
        <Faq data-id="element-13" data-mp="2zlv7qwykd5w4" />
        <FinalCta data-id="element-14" data-mp="2zmepackaxs9m" />
      </main>
      <Footer data-id="element-15" data-mp="2zn6biws0edn8" />
      {showStickyMobileCta && <StickyMobileCta data-id="element-16" data-mp="33m5ck6amdq9e" />}
    </div>;
}